import { render, staticRenderFns } from "./index.vue?vue&type=template&id=25dd247b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=25dd247b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dd247b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25dd247b')) {
      api.createRecord('25dd247b', component.options)
    } else {
      api.reload('25dd247b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=25dd247b&scoped=true&", function () {
      api.rerender('25dd247b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/amont/index.vue"
export default component.exports